import LargeBlueButton from '@components/common/button/LargeBlueButton';
import { GenericAuthContext } from '@src/authContexts';
import { mapStorageError } from '@util/mapFirebaseError';
import firebase from 'firebase/app';
import 'firebase/storage';
import React, { useContext, useState } from 'react';

const PhotoEditor: React.FC = () => {
  const { user } = useContext(GenericAuthContext);

  const userProfile = firebase.storage().ref(`users/${user.uid}/profile/image`);

  const [{ photoUrl, uploadPercent, uploadError }, setUploadState] = useState({
    photoUrl: user.photoURL,
    uploadPercent: -1,
    uploadError: '',
  });

  return (
    <div className='mt-10'>
      {photoUrl ? (
        <img src={photoUrl} className='mb-10 w-40 h-40 object-cover rounded-full'></img>
      ) : (
        <p className='font-raleway text-xl font-medium text-coffee my-10'>No Photo.</p>
      )}
      <input
        id='actual-file-uploader'
        type='file'
        accept='.png,.jpg'
        hidden
        onChange={(e) => {
          if (!e.target.files) {
            return;
          }

          userProfile.put(e.target.files[0]).on(
            firebase.storage.TaskEvent.STATE_CHANGED,
            (snap) => {
              setUploadState((s) => ({
                ...s,
                uploadPercent: (snap.bytesTransferred / snap.totalBytes) * 100,
                uploadError: '',
              }));
            },
            (e) => {
              setUploadState((s) => ({
                ...s,
                uploadPercent: -1,
                uploadError: mapStorageError(e),
              }));
            },
            () => {
              userProfile.getDownloadURL().then((url) => {
                user.updateProfile({ photoURL: url });
                setUploadState((s) => ({
                  ...s,
                  photoUrl: url,
                  uploadPercent: -1,
                }));
              });
            }
          );
        }}
      ></input>
      <LargeBlueButton
        text={'CHOOSE PICTURE'}
        onClick={() => document.getElementById('actual-file-uploader')?.click()}
      ></LargeBlueButton>
      <p className='font-raleway text-xl font-medium text-coffee mt-5'>
        {uploadPercent === -1
          ? ''
          : `Uploading... ${uploadPercent.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            })}%`}
      </p>
      <p className='font-raleway text-xl font-medium text-red-600 mt-5'>{uploadError}</p>
    </div>
  );
};

export default PhotoEditor;
